import { AbstractToggleList } from './AbstractToggleList';
import { AbstractToggleListProps } from './types';

interface ToggleListProps extends AbstractToggleListProps {
  valueToggles: any;
}

export class ToggleList extends AbstractToggleList<ToggleListProps> {

  isValueSelected(value: string) {
    return (this.props as ToggleListProps).valueToggles[value] === true;
  }

}
